<template>
  <div class="upload-base--com">
    <div class="upload-main">
      <div class="el-upload el-upload--text" @dragover="fileDragover" @drop="fileDrop">
        <div class="el-upload-dragger">
          <template v-if="!fileName">
            <label for="fileInput"><i class="el-icon-upload"></i></label>
          </template>
          <template v-else>
            <span class="file-name">{{fileName}}</span>
          </template>
          <label class="el-upload__text" for="fileInput">
            将附件拖到此处，或
            <br>
            <em>点击选择</em>
            <br>
            <!-- <span style="font-size: 12px;">excel\word\zip\pdf格式</span> -->
          </label>
        </div>
        <input
          id="fileInput"
          type="file"
          name="file"
          :accept="acceptList"
          @change="chooseUploadFile"
          class="el-upload__input">
      </div>
    </div>
    <div class="upload-action">
      <el-button type="primary" @click="closeIt" size="mini">{{'关闭'}}</el-button>
      <el-button type="primary" @click="upload" size="mini">{{btnName || '上传'}}</el-button>
    </div>
    <uploadFilePage :percent="percent" @cancel="handleCancel"></uploadFilePage>
    <nut-dialog
      @close="jindu = false"
      v-if="jindu"
      :visible="jindu"
      title="上传进度"
      :noFooter="true">
      <progress :value="percentage" max="100"></progress>{{ percentage }}%
      <p>{{ text1 }}</p>
      <progress v-if="jiexiFlsg" :value="percentageA" max="100"></progress><span v-if="jiexiFlsg">{{ percentageA }}%</span>
      <p>{{ text2 }}</p>
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../api/index'
import uploadFilePage from '../pages/uploadFilePage'
import axios from 'axios'
export default {
  props: ['uploadMethod', 'btnName', 'acceptList', 'extaParam', 'fileSize', 'overSizeTip'],
  data () {
    return {
      fileName: '',
      percent: 0,
      jindu: false,
      percentage: 0,
      percentageA: 0,
      text1: '',
      text2: '',
      jiexiFlsg: false
    }
  },
  methods: {
    // 拖拽上传
    fileDragover (e) {
      e.preventDefault()
    },
    fileDrop (e) {
      e.preventDefault()
      const file = e.dataTransfer.files[0] // 获取到第一个上传的文件对象
      if (!file) return
      if (file.size > ((this.fileSize || 10) * 1000 * 1000)) {
        this.$toast.text('文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''))
        return
      }
      this.batchFile = file
      this.fileName = file.name
    },
    chooseUploadFile (e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > ((this.fileSize || 10) * 1000 * 1000)) {
        this.$toast.text('文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''))
        return
      }
      this.batchFile = file
      this.fileName = file.name
      e.target.value = ''
    },
    upload () {
      if (!this.fileName) {
        this.$toast.text('请选择上传文件')
        return
      }
      this.$emit('beforeUpload')
    },
    closeIt () {
      this.$emit('closeIF')
    },
    doUpload () {
      this.jiexiFlsg = false
      this.text1 = ''
      this.text2 = ''
      var idJ = 0
      this.percentage = 0
      this.percentageA = 0
      this.jindu = true
      var bianliang = setInterval(() => {
        this.percentage = this.percentage + 5
        if (this.percentage >= 98) {
          clearInterval(bianliang)
        }
      }, 500)
      console.log(this.extaParam, 'extaParam')
      console.log(this.uploadMethod, 'uploadMethod')
      this.CancelToken = axios.CancelToken
      this.source = this.CancelToken.source()
      // this.loading = this.$loading()
      api[this.uploadMethod](Object.assign({}, {
        multipartFile: this.batchFile
      }, this.extaParam), (percent) => {
        this.percent = percent
      }, this.source.token).then(res => {
        // this.loading && this.loading.close()
        if (res.code === 200) {
          this.percentage = 100
          clearInterval(bianliang)
          this.text1 = res.message
          idJ = res.data
          this.percentageA = 0
          this.jiexiFlsg = true
          var bianliangA = setInterval(() => {
            this.percentageA = this.percentageA + 1
            if (this.percentageA >= 98) {
              clearInterval(bianliangA)
            }
          }, 1000)
          setTimeout(() => {
            this.percent = 0
          }, 100)
          this.$emit('uploadSuccess', res.data)
          api.cdSummaryTableImport({
            id: idJ
          }).then(resA => {
            if (resA.code === 200) {
              this.percentageA = 100
              clearInterval(bianliangA)
              this.text2 = resA.message
              this.$emit('uploadSuccess', res.data)
              setTimeout(() => {
                this.jindu = false
              }, 1000)
            } else {
              clearInterval(bianliangA)
              this.text2 = resA.message
            }
          })
          setTimeout(() => {
            this.percent = 0
          }, 100)
          this.$emit('uploadSuccess', res.data)
        } else {
          this.$toast.text(res.message || '上传失败')
        }
      })
    },
    handleCancel () {
      setTimeout(() => {
        this.percent = 0
      }, 100)
      this.source.cancel('Operation canceled by the user.')
    }
  },
  components: {
    uploadFilePage
  }
}
</script>

<style lang="scss">
.upload-base--com {
  .upload-main {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .el-upload-right {
      flex: 0;
      .el-form-item {
        margin-bottom: 0;
      }
      .el-cascader {
        margin-bottom: 0!important;
      }
      .el-form-item__error {
        padding-top: 0;
        top: 40px;
      }
      .el-date-editor.el-input {
        width: 172px;
        margin-bottom: 12px;
      }
      .el-select, .el-cascader {
        margin-bottom: 12px;
      }
    }
    .el-upload-dragger {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 140px;
    }
    .el-upload-dragger {
      height: 140px;
    }
    .el-icon-upload {
      margin: 0;
    }
    label {
      display: block;
    }
  }
  .upload-action {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
